import React from "react";

import { useTranslation } from "utils";

import { Drawer, Typography } from "components";

export type FieldSoilExplainerDrawerProps = {
  visible: boolean;
  onClose: () => void;
  dataTestId?: string;
};

const PARAGRAPH_KEYS = ["source", "impact"] as const;

export const FieldSoilExplainerDrawer = ({ visible, onClose, dataTestId = "field-soil-explainer-drawer" }: FieldSoilExplainerDrawerProps) => {
  const { t } = useTranslation("scenarioAnalysis");

  return (
    <Drawer visible={visible} onClose={onClose} title={t("aboutYourField.drawer.title")} titleVariant="h2" dataTestId={dataTestId}>
      <div className="field-soil-explainer-drawer">
        {PARAGRAPH_KEYS.map((key) => (
          <Typography key={key} variant="paragraph-m" color="grey-600">
            {t(`aboutYourField.drawer.${key}`)}
          </Typography>
        ))}
      </div>
    </Drawer>
  );
};

export default FieldSoilExplainerDrawer;
